import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@headlessui/react';
import { UserInviteForm } from '../UserManagement/UserInviteForm';
import { useData } from '../../contexts/DataContext';

interface InviteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onInvite: (userData: unknown) => Promise<void>;
  isSystemLevel?: boolean;
  companyId?: string;
  inviting: boolean;
}

export const InviteUserModal: React.FC<InviteUserModalProps> = ({
  isOpen,
  onClose,
  onInvite,
  isSystemLevel = false,
  companyId,
  inviting,
}) => {
  const { t } = useTranslation();
  const { companies } = useData();
  const companyName = companyId ? companies.find((c) => c.id === companyId)?.name : null;
  const title = companyName
    ? t('user_management.invite_user_to_company', { companyName })
    : t('user_management.invite_user');

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
        <Dialog.Panel className="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full max-h-[90vh] flex flex-col overflow-hidden my-auto">
          <Dialog.Title className="text-lg font-medium flex-shrink-0 p-6 pb-0 text-gray-900 dark:text-gray-100">
            {title}
          </Dialog.Title>
          <div className="flex-1 min-h-0 overflow-y-auto p-6 pt-4">
            {inviting ? (
              <div className="flex justify-center py-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              </div>
            ) : (
              <UserInviteForm
                onInvite={onInvite}
                isSystemLevel={isSystemLevel}
                companyId={companyId}
              />
            )}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
